export interface Definition {
    word: string;
    phonetic?: string;
    meanings: {
        partOfSpeech: string;
        definitions: {
            definition: string;
            example?: string;
            synonyms?: string[];
        }[];
        synonyms?: string[];
    }[];
}

const definitionCache = new Map<string, Definition | null>();

export async function getDefinition(word: string): Promise<Definition | null> {
    const cleanWord = word.toLowerCase().trim();

    if (definitionCache.has(cleanWord)) {
        return definitionCache.get(cleanWord) || null;
    }

    try {
        const response = await fetch(`https://api.dictionaryapi.dev/api/v2/entries/en/${cleanWord}`);
        if (!response.ok) {
            definitionCache.set(cleanWord, null);
            return null;
        }

        const data = await response.json();
        const definition = data[0] as Definition;
        definitionCache.set(cleanWord, definition);
        return definition;
    } catch (error) {
        console.error('Error fetching definition:', error);
        return null;
    }
}
